import { Pill } from './Pill/index'
import { ApprovabilityDecoration } from 'components/elements/ApprovabilityDecoration'
import { useApprovabilityData } from '../store'
import { ApprovabilitySummaryLevelMap } from '../constants'
import { SummaryLevelEnum } from 'generated/api'
import { PendingFC } from 'components/patterns/suspense/componentWrappers'
import { SizeMods } from 'components/styles/primitives/modifiers/size'
import { css, keyframes } from '@emotion/react'
import { colors } from 'parameters/ui'

interface Props {
	level: SummaryLevelEnum
}
const CustomPill: PendingFC<Props> = props => {
	const config = ApprovabilitySummaryLevelMap[props.pending ? 'UNKNOWN' : props.level]
	const text = props.pending ? 'CHECKING APPROVABILITY' : `${props.level} Approvability`.toUpperCase()
	return (
		<Pill
			modifiers={[SizeMods({ minWidth: '12vc' }), props.pending && movingBg]}
			size="big"
			color={config.color}
			decoration={<ApprovabilityDecoration value={config.percentage} />}
		>
			{text}
		</Pill>
	)
}

export const ThumbPill = () => {
	const [{ summary, loading }] = useApprovabilityData()
	if (!loading && summary?.level) {
		return <CustomPill level={summary.level} />
	} else {
		return <CustomPill pending />
	}
}

const gradient = keyframes`
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
`

const movingBg = css`
	background: linear-gradient(
		90deg,
		${colors.secondaryDarkGrey1},
		${colors.primaryLightGrey1},
		${colors.secondaryDarkGrey1}
	);
	background-size: 200% 100%;
	animation: ${gradient} 4s linear infinite;
`
